import { createApi } from '@reduxjs/toolkit/query/react';

import { URL } from 'api';
import { CourseEnrollment } from 'types';
import { cacheByIdArg, cacheListAndByIdArgProperty } from 'utils/query-cache';

import { apiQuery } from '../../query';
import {
  courseSubmissionsApi,
  courseSubmissionsTagType,
} from '../course-submissions';
import {
  courseStepSubmissionsApi,
  courseStepSubmissionsTagType,
} from '../course-step-submissions';

import {
  CourseEnrollmentPayload,
  CourseEnrollmentRequest,
  CourseEnrollmentResponse,
} from './types';

const tagType = 'COURSE_ENROLLMENTS';

const tagTypes = [tagType];

export const courseEnrollmentsApi = createApi({
  tagTypes,
  baseQuery: apiQuery,
  reducerPath: 'courseEnrollmentsApi',
  endpoints: (build) => ({
    details: build.query<CourseEnrollment, CourseEnrollmentRequest>({
      transformResponse: (response: CourseEnrollmentResponse) => response.data,
      providesTags: (result, error, { id }) =>
        cacheByIdArg(tagType)(result, error, id),
      query: ({ id }) => ({
        method: 'get',
        url: URL.COURSE_ENROLLMENTS_BY_COURSE_ID.replace(':id', id),
      }),
    }),

    create: build.mutation<void, CourseEnrollmentPayload>({
      query: (data) => {
        return {
          data,
          method: 'post',
          url: URL.COURSE_ENROLLMENTS,
        };
      },
      invalidatesTags: (result, error, arg) => {
        if (error) return [];
        return cacheListAndByIdArgProperty(tagType)(result, error, {
          id: arg.courseId,
        });
      },

      onQueryStarted: async (args, { dispatch, queryFulfilled }) => {
        try {
          await queryFulfilled;
          dispatch(
            courseSubmissionsApi.util.invalidateTags([courseSubmissionsTagType])
          );
          dispatch(
            courseStepSubmissionsApi.util.invalidateTags([
              courseStepSubmissionsTagType,
            ])
          );
        } catch (error) {
          console.error(error);
        }
      },
    }),
  }),
});

export const { useDetailsQuery, useCreateMutation } = courseEnrollmentsApi;

export { tagType as courseEnrollmentsTagType };
